import {
  Checkbox,
  Flex,
  FlexAnchor,
  mdBumps,
  PrimaryButton,
  Typo,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback, useState } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { ProductConfig } from '../../../../../../state/configuration'
import { WriskTrans } from '../../../../../organisms/trans'

const tKey = TKey('components.start-payment')

export const StartPaymentSection: FunctionComponent<{
  product: ProductConfig
  onConfirm: () => void
  loading: boolean
}> = ({ product, onConfirm, loading }) => {
  const { t } = useWriskTranslation()

  const [proposalTerms, setProposalTerms] = useState<Record<string, boolean>>(
    product.proposalTerms?.reduce((acc, it) => ({ ...acc, [it]: false }), {}) ?? {},
  )

  const onChange = useCallback(
    (id: string) => (checked: boolean) =>
      setProposalTerms((current) => ({ ...current, [id]: checked })),
    [setProposalTerms],
  )

  const confirmSections = Object.entries(proposalTerms).map(([id, checked]) => (
    <FlexAnchor
      key={id}
      as='label'
      htmlFor={id}
      backgroundColor='chalk'
      justifyContent='flex-start'
      width={1}
      variant='inset'
      px={mdBumps}
      py={3}
    >
      <Checkbox id={id} mr={4} value={checked} onChange={onChange(id)} />
      <Typo>
        <WriskTrans t={t} i18nKey={tKey('agreements', id)} />
      </Typo>
    </FlexAnchor>
  ))

  const disclaimer = t(tKey('disclaimer'), { defaultValue: null })

  return (
    <>
      {confirmSections.length > 0 && (
        <Flex width={1} py={2} flexWrap='wrap' variant='raised' flexDirection='column'>
          {confirmSections}
        </Flex>
      )}

      {disclaimer && (
        <Typo mt={mdBumps} as='p'>
          {disclaimer}
        </Typo>
      )}

      <PrimaryButton
        mt={xlBumps}
        data-testid='button-continue'
        layout='fixed'
        onClick={onConfirm}
        loading={loading}
        disabled={!Object.values(proposalTerms).every(Boolean)}
      >
        {t(tKey('actions.continue'))}
      </PrimaryButton>
    </>
  )
}
